import React, { useEffect } from "react";
import GeniustextInput from "../../utility/component/mastertext";
import { useSelector } from "react-redux";
import { selectWidth } from "../../utility/Redux/profile";
import { PartyColumns } from "./columns";
import currencySymbolMap from "currency-symbol-map/map";
import { getAllISOCodes } from "iso-country-currency";
import GeniusSelectWithTitle from "../../utility/component/geniusComponents/customeSelect";

const AddressInformation = ({
  address,
  setAddress,
  selectedState,
  setAddressMissingId,
  addressMissingId,
  statesList,
  citysList,
  handleCountryChange,
  pinCode,
  setPinCode,
  handleStateChange,
  city,
  setCity,
  selectedCountry,
  currencyName,
  setCurrencyName,
  setTabScreen,
  formRef,
  addressRef,
  countryList,
}) => {
  const windowWidth = useSelector(selectWidth);
  const currencyData = currencySymbolMap;

  const symbleList = getAllISOCodes();
  const symbelList2 = symbleList.map((d) => {
    return {
      name: `${d.symbol} ---- ${d.currency}`,
      value: d.currency,
      isoCode: d.iso,
      symbol: d.symbol,
    };
  });

  const columns = PartyColumns(windowWidth);
  const symbolList = currencyName
    ? symbelList2.filter((column) => column.value === currencyName)
    : [
        {
          symbol: "",
        },
      ];
  const symbl = symbolList[0]?.symbol;

  return (
    <>
      <div
        id={"Address Details"}
        className="grid md:grid-cols-[200px,1fr] ll:grid-cols-[400px,1fr]  border-b pb-2 p-3"
      >
        <div>
          <div className="font-semibold text-[16px] text-black  w-fit ">
            Address Details
          </div>
          <div className="text-[12px] text-gray-600  w-fit ">
            Edit party address details
          </div>
        </div>
        <div className="   grid grid-cols-2 md:grid-cols-4 gap-2">
          <GeniustextInput
            title={"Address"}
            grid={true}
            type={"text"}
            id={"address"}
            value={address}
            onChange={(e) => {
              setAddress(e.target.value);
            }}
            autofocus={true}
          />
          <GeniustextInput
            title={"Country"}
            grid={true}
            option={countryList.map((c) => {
              return {
                label: c.countryName,
                value: c.countryName,
                name: c.countryName,
              };
            })}
            value={selectedCountry}
            onChange={handleCountryChange}
          />

          <GeniustextInput
            title={"State"}
            grid={true}
            value={selectedState}
            option={statesList.map((s) => {
              return {
                label: s.name,
                value: s.name,
                name: s.name,
              };
            })}
            onChange={handleStateChange}
          />
          <GeniustextInput
            title={"City"}
            grid={true}
            value={city}
            onChange={(e) => {
              setCity(e.target.value);
            }}
            option={citysList.map((s) => {
              return {
                label: s.name,
                value: s.name,
                name: s.name,
              };
            })}
          />
          <GeniustextInput
            title={"Pin-Code"}
            grid={true}
            type={"text"}
            value={pinCode}
            onChange={(e) => {
              setPinCode(e.target.value);
            }}
          />
        </div>
      </div>

      <div
        id={"Item Price"}
        className="grid md:grid-cols-[200px,1fr] ll:grid-cols-[400px,1fr]  border-b pb-2 p-3"
      >
        <div>
          <div className="font-semibold text-[16px] text-black  w-fit ">
            Currency Details
          </div>
          <div className="text-[12px] text-gray-600  w-fit ">
            Edit currency details
          </div>
        </div>

        <div className="   grid grid-cols-2 l:grid-cols-4 gap-2">
          <GeniusSelectWithTitle
            height={"200px"}
            title={"Currency Name"}
            country={true}
            grid={true}
            options={symbelList2}
            value={currencyName}
            setValue={setCurrencyName}
            handleClick={(e) => {
              setCurrencyName(e);
            }}
          />

          <GeniustextInput
            title={"Currency Symbol"}
            type={"text"}
            grid={true}
            value={symbl}
          />
        </div>
      </div>
    </>
  );
};

export default AddressInformation;
